import BaseAPI from '../base'

function finish(cafe_id, account, code) {
    return BaseAPI.post(`poster/finish/${cafe_id}`, {
        code,
        account
    });
}

function importMenu(cafe_id) {
    return BaseAPI.post(`poster/import_menu/${cafe_id}`);
}

function importWorkers(cafe_id) {
    return BaseAPI.post(`poster/import_workers/${cafe_id}`);
}

function getProductsList(cafe_id) {
    return BaseAPI.get(`poster/products_list/${cafe_id}`);
}

function getTablets() {
    return BaseAPI.get(`poster/tablets`);
}

function importTables(cafe_id) {
    return BaseAPI.post(`poster/import_tables/${cafe_id}`);
}

function getSpots(cafe_id) {
    return BaseAPI.get(`poster/spots/${cafe_id}`);
}

function getHealth(cafe_id) {
    return BaseAPI.get(`poster/health/${cafe_id}`);
}

function getGeneralSettings(cafe_id) {
    return BaseAPI.get(`poster/general_settings/${cafe_id}`);
}

function resyncAllPrices(cafe_id) {
    return BaseAPI.post(`poster/resync_prices/${cafe_id}`);
}

function getPendingChanges(menu_id) {
    return BaseAPI.get(`poster/pending_changes/${menu_id}`);
}

function batchPendingChanges(statuses_map) {
    return BaseAPI.post(`poster/pending_changes/batch`, statuses_map);
}

export default {
    finish,
    importMenu,
    importWorkers,
    getProductsList,
    getTablets,
    importTables,
    getSpots,
    getHealth,
    getGeneralSettings,
    resyncAllPrices,
    getPendingChanges,
    batchPendingChanges
}